import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasAccessToRoute } from '../utils/routeTabMapping';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, tabs, tabsLoading } = useAuth();
  const location = useLocation();

  // First check: user must be authenticated
  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Wait for tabs to load before checking permissions
  if (tabsLoading) {
    return null; // Or return a loading spinner
  }


  // Second check: user must have access to the route's required tab
  const currentPath = location.pathname;

  if (currentPath === '/') { 
    <Navigate to="/dashboard" replace />;
  }
  const userHasAccess = hasAccessToRoute(currentPath, tabs);
  // const userHasAccess = true;

  if (!userHasAccess) {
    // Redirect to 403 forbidden page
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
